module.exports = __webpack_public_path__ + "assets/events-white.04a13245.svg";